import {EventBroker} from "../../../lib/utils/event-broker";

export const EVENTS = {
    SAVED: 'SAVED',
    INIT: 'INIT',
}

export const customTemplateSizeEventBroker = new EventBroker();